/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved.
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export function getLauncherWebviewClient() {
  try {
    return window && (window as any).JusticeLauncherWebviewClient;
  } catch (error) {
    return undefined;
  }
}

export function isInLauncher() {
  return !!getLauncherWebviewClient();
}
